import React from "react"
import types from "prop-types"
import { activityHubFormEditPath } from "utils/routeHelpers"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import ExpandMenuEllipsisButton from "shared/buttons/ExpandMenuEllipsisButton"

const FormMenu = ({
  formSlug, onCopy, onDelete, userCanCopy, userCanDelete, userCanEdit,
}) => {
  if (!userCanEdit && !userCanCopy && !userCanDelete) return null

  return (
    <ExpandMenu expandMenuComponent={<ExpandMenuEllipsisButton />}>
      {
        userCanEdit && (
          <ExpandMenuItem href={activityHubFormEditPath(formSlug)}>
            Edit
          </ExpandMenuItem>
        )
      }
      {
        userCanCopy && (
          <ExpandMenuItem onClick={onCopy}>
            <span>Copy</span>
          </ExpandMenuItem>
        )
      }
      {
        userCanDelete && (
          <ExpandMenuItem onClick={onDelete}>
            <span>Delete</span>
          </ExpandMenuItem>
        )
      }
    </ExpandMenu>
  )
}

FormMenu.propTypes = {
  formSlug: types.string.isRequired,
  onCopy: types.func.isRequired,
  onDelete: types.func.isRequired,
  userCanCopy: types.bool.isRequired,
  userCanDelete: types.bool.isRequired,
  userCanEdit: types.bool.isRequired,
}

export default FormMenu
